import { ChatMarkdownRenderer } from "src/base-components/Chat/PromptBox/ChatMarkdownRenderer";

type ChatUserBubbleProps =
  | {
      message: string;
      dataLoc?: string;
      children?: never;
    }
  | {
      children: React.ReactNode;
      dataLoc?: string;
      message?: never;
    };

export const ChatUserBubble: React.FC<ChatUserBubbleProps> = ({
  message,
  dataLoc,
  children,
}) => {
  return (
    <div data-loc={dataLoc} className="max-w-[75%] rounded-lg bg-gray-100 p-2">
      {message === undefined ? (
        children
      ) : (
        <ChatMarkdownRenderer content={message} />
      )}
    </div>
  );
};
